import api from '@/utils/api.js'
import msgWarning from '@/tools/msgwarning.js'
// 权限菜单相关接口 by Master Wan

// 添加功能（菜单）
// payload: 
// color: "" //字体颜色
// imgURL: "https://image.jxc4.com/image/432cc6451cd5376dd8f13ca46600d731.tem.png" //图标地址
// level: 1 等级
// name: "首页" 菜单名
// parentID: 0 父级ID
export const addMenu = async (payload, noLoading = true) => {
    let form = new FormData()
    form.append('payload ', JSON.stringify(payload))
    try {
        let res = await api('v2/power/AddMenu', {
            method: 'POST',
            data: form,
            noLoading
        })
        return res
    } catch (e) {
        console.error('AddMenu', e)
        msgWarning(e)
        throw e
    }
}


//添加角色
//  name 角色名
export const addRole = async (name, noLoading = true) => {
    let form = new FormData()
    form.append('name', name)
    try {
        let res = await api('v2/power/AddRole', {
            method: 'POST',
            data: form,
            noLoading
        })
        return res
    } catch (e) {
        console.error('AddRole', e)
        throw e
    }
}


//获取菜单
export const getMenu = async (userID='' , noLoading = true) => {
    try {
        let res = await api(`v2/power/GetMenu?userID=${userID}`, {
            noLoading
        })
        return res
    } catch (e) {
        console.error('GetMenu', e)
        msgWarning(e)
        throw e
    }
}


//查询用户角色
export const getUserRole = async (userID = '', noLoading = true) => {

    try {
        let res = await api(`v2/power/GetUserRole?userID=${userID}`, {
            noLoading
        })
        return res
    } catch (e) {
        console.error('GetUserRole', e)
        msgWarning(e)
        throw e
    }
}


//查询角色的菜单
//  roleID 用户ID int
export const getRoleMenu = async (roleID, noLoading = true) => {

    try {
        let res = await api(`v2/power/GetRoleMenu?roleID=${roleID}`, {
            noLoading
        })
        return res
    } catch (e) {
        console.error('GetRoleMenu', e)
        throw e
    }
}


//查询角色
export const getRole = async (name,noLoading = true) => {
    try {
        let url = name ? `v2/power/GetRole?name=${name}`: 'v2/power/GetRole'
        let res = await api(url, { noLoading })
        return res
    } catch (e) {
        console.error('GetRole', e)
        throw e
    }
}


//修改菜单
export const UpdateMenu = async (json, noLoading = true) => {
    let form = new FormData()
    form.append('payload', json.payload)
    form.append('menuID', json.menuID)
    form.append('isDelete', json.isDelete)
    try {
        let res = await api('v2/power/UpdateMenu', {
            method: 'PUT',
            data: form,
            noLoading
        })
        return res
    } catch (e) {
        console.error(e)
        throw e
    }
}


//修改角色
export const UpdateRole = async (json, noLoading = true) => {
    let form = new FormData()
    form.append('name', json.name)
    form.append('roleID', json.roleID)
   if(json.brandID) form.append('brandID', json.brandID)
   if(json.cityCodes) form.append('cityCodes', JSON.stringify(json.cityCodes))
   if(json.storeIDs) form.append('storeIDs', JSON.stringify(json.storeIDs))
    form.append('isDelete', json.isDelete)
    try {
        let res = await api('v2/power/UpdateRole', {
            method: 'PUT',
            data: form,
            noLoading
        })
        return res
    } catch (e) {
        console.error(e)
        throw e
    }
}


//修改角色菜单
export const UpdateRoleMenu = async (roleIDs, menuIDs, noLoading = true) => {
    let form = new FormData()
    form.append('roleIDs', JSON.stringify([roleIDs]))
    form.append('menuIDs', JSON.stringify(menuIDs))
    try {
        let res = await api('v2/power/UpdateRoleMenu', {
            method: 'PUT',
            data: form,
            noLoading
        })
        return res
    } catch (e) {
        console.error(e)
        throw e
    }
}


//修改用户角色
export const UpdateUserRole = async (json, noLoading = true) => {
    let form = new FormData()
    form.append('userIDs', JSON.stringify(json.userIDs))
    form.append('roleIDs', JSON.stringify(json.roleIDs))
    try {
        let res = await api('v2/power/UpdateUserRole', {
            method: 'PUT',
            data: form,
            noLoading
        })
        return res
    } catch (e) {
        console.error(e)
        throw e
    }
}


// WEBPACK FOOTER //
// ./src/apis/permission.js